import React from "react";
import { Page, Document, StyleSheet } from "@react-pdf/renderer";
import InvoiceTitle from "./Heading";
import InvoiceNo from "./Number";
import InvoiceItemsTable from "./Items-Table";
import Signature from "./Signature";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 40,
    lineHeight: 1.5,
    flexDirection: "column",
  },
});

const AllPackingSlipsPdfDocument = ({ slips, loggedInUser }) => (
  <Document>
    {slips.map((slip, index) => (
      <Page key={index} size="A4" style={styles.page} orientation="portrait" wrap>
        <InvoiceTitle invoice={slip} />
        <InvoiceNo invoice={slip} />
        <InvoiceItemsTable invoice={slip} items={slip.products} />
        <Signature invoice={slip} user={loggedInUser} />
      </Page>
    ))}
  </Document>
);

export default AllPackingSlipsPdfDocument;